import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoLink from 'eco-design/base/eco-link';
import React from 'react';
import styles from './index.module.scss';


const EcoBlogCard = ({ ...reset }) => {
    const item = reset || {};
    const itemStyleComp = {
        '--blog-item-titleColor': item.titleColor,
        '--blog-item-labelColor': item.labelColor,
    } as React.CSSProperties;

    return (
        <div className={styles['eco-blog-items-card']} style={itemStyleComp}>
            <EcoLink href={item.href} className={`eco-blog-items-card-img`}>
                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} />
            </EcoLink>
            <div className={`eco-blog-items-card-msg`}>
                <EcoLink href={item.categoryHref} className={`eco-blog-items-card-label`}>
                    {item.label}
                    <div className={`eco-blog-items-card-msg-time`}>{item.timer}</div>
                </EcoLink>
                <EcoLink href={item.href} className={`eco-blog-items-card-title`}>
                    {item.title}
                </EcoLink>
            </div>
        </div>
    );
};

export default EcoBlogCard;
